import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      title: 'Build Your Robot',
      description: 'Assemble your robot using the included 3D printed parts, servo motors, wheels, and Micro:Bit following our step-by-step guide.'
    },
    {
      title: 'Use our IDE',
      description: 'Use our visual programming interface on your browser to control your robot.'
    },
    {
      title: 'Create Programs',
      description: 'Drag and drop blocks to build programs that control your robots movements and actions.'
    },
    {
      title: 'Complete Challenges',
      description: 'Progress through a series of computational thinking challenges that gradually increase in complexity.'
    }
  ];

  return (
    <section id="how-it-works" className="section how-it-works">
      <div className="container">
        <div className="section-title">
          <h2>How It Works</h2>
          <p>From unboxing to programming your robot</p>
        </div>

        <div className="steps">
          {steps.map((step, index) => (
            <div className="step" key={index}>
              <div className="step-number"></div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;